import { useGoogleLogin } from '@react-oauth/google';
import { useContext } from 'react';
import { UserContext } from "../../contexts/UserContext"
import { useNavigate } from 'react-router-dom';
import "./customGoogleButton.css"

export function CustomGoogleButton({ text }) {
    const userDataContext = useContext(UserContext)
    const { dispatch } = userDataContext

    const navigate = useNavigate()
    // using the useGoogleLogin hook is complicated but you can make the button however you like.
    const loginClient = useGoogleLogin({
        onSuccess: async tokenResponse => {
            // this function return object which has 6 properties : access_token, authuser, expires_in, prompt, scope & token_type. the access token is necessary for authorization while fetching userInfo from the uri below. if fetch is successful, it returns an object which has 7 properties : email, email_verified, family_name, given_name, name, picture & sub. sub is a unique identifier for the user like a google ID. this method is done on the client side
            console.log(tokenResponse);
            // fetching userinfo can be done on the client or the server
            const userInfo = await fetch("https://www.googleapis.com/oauth2/v3/userinfo", {
            
            //if the user is logged in his google account, using this uri allow him to log in with google just by clicking on his account. no need for password
            /* const userInfo = await fetch("https://www.googleapis.com/oauth2/v3/userinfo?" +
                "redirect_uri=https://developers.google.com/oauthplayground&response_type=token&client_id=283221269197-rdpd3ahip21uo0a058sp72erp3k86e85.apps.googleusercontent.com&scope=https://mail.google.com/&login_hint=omaradhona@gmail.com", { */
            
                headers: {
                    Authorization: `Bearer ${tokenResponse.access_token}`
                },
            })
            
            const data = await userInfo.json()
            
            if(data){
                console.log(data)
            }
        },
        // flow: 'implicit', // implicit is the default
    });

    const loginBackend = useGoogleLogin({
        onSuccess: async ({ code }) => {
            // this functino returns a code which is a token. this token is sent to the backend and exchanged for tokens using "oAuth2Client" module. a id_token is taken from the tokens and decoded with javascript on the backend. this decoded token has the user info which is then used to either sign him up or log him in.
            
            // fetching userinfo can be done on the client or the server
            const userInfo = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/googleSignin`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ code })
            })
            
            const data = await userInfo.json()
            
            if(userInfo.ok) {
                const { user, token } = data
                localStorage.setItem("user", JSON.stringify({ user, token }))
                dispatch({ type: "LOGIN", payload: { user, token } })
                navigate("/")
                console.log(data)
            }
        },
        flow: 'auth-code',        
    });

    return (
        <div onClick={() => loginBackend()} id="container" className="haAclf" style={{ width: "100%" }}>
            <div tabIndex="0" role="button" aria-labelledby="button-label" className="nsm7Bb-HzV7m-LgbsSe  hJDwNd-SxQuSe i5vt6e-Ia7Qfc uaxL4e-RbRzK">
                <div className="nsm7Bb-HzV7m-LgbsSe-MJoBVe"></div>
                <div className="nsm7Bb-HzV7m-LgbsSe-bN97Pc-sM5MNb">
                    <div className="nsm7Bb-HzV7m-LgbsSe-Bz112c">
                        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48" className="LgbsSe-Bz112c"><g><path fill="#EA4335" d="M24 9.5c3.54 0 6.71 1.22 9.21 3.6l6.85-6.85C35.9 2.38 30.47 0 24 0 14.62 0 6.51 5.38 2.56 13.22l7.98 6.19C12.43 13.72 17.74 9.5 24 9.5z"></path><path fill="#4285F4" d="M46.98 24.55c0-1.57-.15-3.09-.38-4.55H24v9.02h12.94c-.58 2.96-2.26 5.48-4.78 7.18l7.73 6c4.51-4.18 7.09-10.36 7.09-17.65z"></path><path fill="#FBBC05" d="M10.53 28.59c-.48-1.45-.76-2.99-.76-4.59s.27-3.14.76-4.59l-7.98-6.19C.92 16.46 0 20.12 0 24c0 3.88.92 7.54 2.56 10.78l7.97-6.19z"></path><path fill="#34A853" d="M24 48c6.48 0 11.93-2.13 15.89-5.81l-7.73-6c-2.15 1.45-4.92 2.3-8.16 2.3-6.26 0-11.57-4.22-13.47-9.91l-7.98 6.19C6.51 42.62 14.62 48 24 48z"></path><path fill="none" d="M0 0h48v48H0z"></path></g></svg>
                    </div>
                    <span className="nsm7Bb-HzV7m-LgbsSe-BPrWId">{text} with Google</span>
                    <span className="L6cTce" id="button-label">Sign up with Google</span>
                </div>
            </div>
        </div>
    )
}